/** Routes of the Document Intelligence module, shared by its pages. */
export const UPLOAD_DOCUMENT_PATH = '/document-intelligence/upload';
export const SAVED_DOCUMENTS_PATH = '/document-intelligence/saved';
/** A finished run that has NOT been saved yet; the result arrives in router
 *  state, since there is no id to fetch it by. */
export const DOCUMENT_RESULT_PATH = '/document-intelligence/result';
/** One saved document: this + '/<id>'. */
export const DOCUMENT_VIEW_BASE_PATH = '/document-intelligence/documents';
export const DOCUMENT_MASTER_BASE_PATH = '/document-intelligence/master';
